export default [
  [`Размеры`, `3XL`, `4XL`, `5XL`],
  [`Ширина`, `64`, `65`, `66`],
  [`Длина`, `77`, `81`, `82`]
];
